import _extends from "@babel/runtime/helpers/esm/extends";
import { Button } from '../../Button';
import Stack from '@mui/material/Stack';
import { Checkbox } from '../../Checkbox';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function LeftContainer(props) {
  var _Checkbox;
  var _props$checkbox = props.checkbox,
    checkbox = _props$checkbox === void 0 ? true : _props$checkbox,
    checkboxText = props.checkboxText,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    customNode = props.customNode,
    icon = props.icon,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    onChangeCheckbox = props.onChangeCheckbox,
    onTertiaryButtonClick = props.onTertiaryButtonClick,
    tertiaryButtonProps = props.tertiaryButtonProps,
    tertiaryButtonText = props.tertiaryButtonText;
  if (customNode) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: customNode
    });
  } else {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [checkbox && (isMobile ? /*#__PURE__*/_jsx(Stack, {
        width: !tertiaryButtonProps ? '100%' : '206px',
        children: _Checkbox || (_Checkbox = /*#__PURE__*/_jsx(Checkbox, {
          checked: checked,
          label: checkboxText,
          onChange: onChangeCheckbox,
          size: "sm"
        }))
      }) : /*#__PURE__*/_jsx(Checkbox, {
        checked: checked,
        label: checkboxText,
        onChange: onChangeCheckbox,
        size: "sm"
      })), (tertiaryButtonProps || tertiaryButtonText) && /*#__PURE__*/_jsx(Button, _extends({
        onClick: onTertiaryButtonClick,
        size: "large",
        startIcon: icon,
        variant: "link-gray"
      }, tertiaryButtonProps, {
        children: tertiaryButtonText
      }))]
    });
  }
}